export default __webpack_public_path__ + "static/partner_of_the_year-938dcd66aa0c42c939d9824f3f3f261f.svg";